import { render, staticRenderFns } from "./base-icon.vue?vue&type=template&id=15fa5aac&scoped=true&"
import script from "./base-icon.vue?vue&type=script&lang=js&"
export * from "./base-icon.vue?vue&type=script&lang=js&"
import style0 from "./base-icon.vue?vue&type=style&index=0&id=15fa5aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa5aac",
  null
  
)

export default component.exports